import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1082Status: 'idle',
    startProcess1082Error: undefined as any,
    loadUserParamsProcess1082Status: 'idle',
    loadUserParamsProcess1082Error: undefined as any,

    process1082List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1082 = createAsyncThunk('process1082Slice/startProcess1082', async ({ process1082 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1082/`,
        prepareData(process1082),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1082Status } = getState().process1082Slice
        return startProcess1082Status !== 'pending'
    }
})

export const loadUserParamsProcess1082 = createAsyncThunk('process1082Slice/loadUserParamsProcess1082', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1082/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1082Status } = getState().process1082Slice
        return loadUserParamsProcess1082Status !== 'pending'
    }
})

const Process1082Slice = createSlice({
    name: 'process1082Slice',
    initialState,
    reducers: {
        resetstartProcess1082: (state) => {
            state.job = undefined
            state.startProcess1082Error = undefined
        },
        resetstartProcess1082Error: (state) => {
            state.startProcess1082Error = undefined
        },
        resetloadUserParamsProcess1082: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1082Error = undefined
        },
        resetloadUserParamsProcess1082Error: (state) => {
            state.loadUserParamsProcess1082Error = undefined
        },
        removeFromProcess1082ListById: (state, action) => {
            state.process1082List = state.process1082List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1082ListByIds: (state, action) => {
            state.process1082List = state.process1082List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1082List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1082Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1082List = []
            state.startProcess1082Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1082.pending, (state) => {
            state.startProcess1082Status = 'pending'
            state.startProcess1082Error = undefined
        })
        builder.addCase(startProcess1082.fulfilled, (state, action) => {
            state.startProcess1082Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1082.rejected, (state, action) => {
            state.startProcess1082Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1082Error = action.error.message
            } else {
                state.startProcess1082Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1082.pending, (state) => {
            state.loadUserParamsProcess1082Status = 'pending'
            state.loadUserParamsProcess1082Error = undefined
        })
        builder.addCase(loadUserParamsProcess1082.fulfilled, (state, action) => {
            state.loadUserParamsProcess1082Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1082.rejected, (state, action) => {
            state.loadUserParamsProcess1082Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1082Error = action.error.message
            } else {
                state.loadUserParamsProcess1082Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1082,
    resetstartProcess1082Error,
    resetloadUserParamsProcess1082,
    resetloadUserParamsProcess1082Error,
    removeFromProcess1082ListById,
    removeFromProcess1082ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1082Slice.actions
export default Process1082Slice.reducer
